import { SET_CURRENT_STORE, SET_PILOT_STORE, SET_REGIONAL_SELECTIONS } from './actionCreators';
import getThdStore from '../utils/getThdStoreInfo';
import isStoreEnabled from '../utils/isStoreEnabled';

export const setStore = (store, previousStoreId) => (dispatch) => {
  if (store) {
    dispatch({
      type: SET_CURRENT_STORE,
      payload: {
        isStoreEnabled: isStoreEnabled(store.storeId),
        storeId: store.storeId,
        zipcode: store.address && store.address.postalCode,
        storeInfo: store,
        previousStoreId,
      },
    });
  } else {
    dispatch({
      type: SET_CURRENT_STORE,
      payload: {
        storeId: getThdStore().storeNumber || 121,
      },
    });
  }
};

export const setRegionalSelections = (regionalSelections) => (dispatch) => {
  dispatch({
    type: SET_REGIONAL_SELECTIONS,
    payload: {
      regionalSelections
    },
  });
};

export const setPilotStore = (store) => (state, dispatch) => {
  dispatch({
    type: SET_PILOT_STORE,
    payload: {
      ...state,
      pilot: store.pilot,
    },
  });
};
